import { Link } from "react-router-dom";
import { useGetNotices } from "hooks/common/useGetNotices";
import { isNewPost } from "hooks/utils/util";

const BannerNotice = ({ type }: { type: string }) => {
    const searchForm = {
        category: type,
        search: "subject",
        searchtxt: "",
        page: 1,
        limit: 4,
    };
    const { data } = useGetNotices(searchForm);

    return (
        <div className="flex flex-col w-[588px] rounded-[20px] pt-[15px] px-[38px] h-[262px] bg-white border responsive1200:w-full">
            <div className="flex justify-between items-center">
                <p className="text-[22px] font-bold text-[#333]">공지사항</p>
                <Link to="/support/notices" className="text-[#bbb] text-[40px] font-thin pb-2">
                    +
                </Link>
            </div>

            {data && data?.data_list.length > 0 ? (
                <div className="flex-1 flex flex-col">
                    {data.data_list.slice(0, 4).map(item => {
                        return (
                            <Link
                                to={`/support/notices/${item.list_no}`}
                                key={item.list_no}
                                className="flex items-center py-[8px] px-[10px] hover:underline gap-[10%]"
                            >
                                <div className="flex-1 flex items-center text-[#666666] text-[15px] truncate">
                                    <p className="truncate">{item.subject}</p>
                                    {isNewPost(item.w_date) && (
                                        <span className="w-[18px] h-[18px] bg-[#27398c] text-white flex items-center justify-center text-[10px] ml-[10px] shrink-0">
                                            N
                                        </span>
                                    )}
                                </div>
                                <span className="text-[#666666] text-[13px]">{item.w_date}</span>
                            </Link>
                        );
                    })}
                </div>
            ) : (
                <div className="flex-1 flex justify-center text-[14px] text-[#666666] cursor-default mt-[10%] responsive1200:mt-[6%]">
                    등록된 게시글이 없습니다.
                </div>
            )}
            <div></div>
        </div>
    );
};

export default BannerNotice;
